import { render, staticRenderFns } from "./ClientCreateCourseAssignment.vue?vue&type=template&id=18307a44&"
import script from "./ClientCreateCourseAssignment.vue?vue&type=script&lang=js&"
export * from "./ClientCreateCourseAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports